import { getEnv } from "../../../utils/env"
import queryString from "query-string"
import { getRequest } from "../../mp-utils/generic-utils"

export const checkDuplication = async (
  email: string,
  username: string,
  districtId: string
): Promise<void> => {
  const dupQuery = queryString.stringify({
    email,
    username,
    schoolDistrict: districtId
  })
  const checkDupUrl = `${getEnv(
    "CLOUD_FUNCTION_ROOT"
  )}/validationGroup-checkDuplication?${dupQuery}`

  const response = await getRequest(checkDupUrl)

  if (JSON.parse(response).error) {
    throw JSON.parse(response).error
  }
}
